// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"ar7ylLVf","pageNumber":"jdLvN9Rm","dots":"D6IHOq7P","active":"QpxrLO_g","navArrow":"k_1NwmS8","disabled":"D9lTD8Ov"};